import AppNavigation from "./navigation"
import {BrowserRouter} from "react-router-dom"
import {ConfigProvider} from "antd"
import "./css/index.css"
import "./css/media.css"
import "./css/ant.css"
import "./css/slider.css"
import "./css/maplibre.css"
import Styled from "./inizialize/Styled"
import {MapProvider} from "react-map-gl/maplibre"

const App = () => {
	return (
		<BrowserRouter>
			<ConfigProvider theme={{
				token: {
					fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
					fontSize: 18
					/*colorLink: "#000000",
					linkHoverDecoration: "underline"*/
				}
			}}>
				<Styled>
					<MapProvider>
						<AppNavigation/>
					</MapProvider>
				</Styled>
			</ConfigProvider>
		</BrowserRouter>
	)
}

export default App


